import { createSelector } from "reselect";
import { isEmpty, forIn } from "lodash";

const defaultPreference = {
  state: [],
  country: [],
  cache: true
};
//EXTRACT THE PART OF THE STATE
const getData = state => {
  const preference = state.user.partnerPreference;
  //get all static data
  const { data } = state;

  if (isEmpty(data.country)) {
    return defaultPreference;
  }

  //if preference is empty return the default value
  if (isEmpty(preference)) {
    return defaultPreference;
  }
  //format the preference and return it
  try {
    let object = {};
    forIn(preference, (value, key) => {
      if (key === "country") {
        if (value.all) {
          object[key] = [];
        } else {
          let _data = [];
          forIn(value, (nestedValue, nestedKey) => {
            if (nestedKey !== "all") {
              _data.push({
                value: nestedKey,
                label: data.country[nestedKey].label,
                description: data.country[nestedKey].description
              });
            }
          });
          object[key] = _data;
        }
      } else if (key === "state") {
        if (value.all) {
          object[key] = [];
        } else {
          if (isEmpty(data.state)) {
            object[key] = [];
          } else {
            let _data = [];
            forIn(value, (nestedValue, nestedKey) => {
              if (nestedKey !== "all") {
                if (data.state[nestedKey]) {
                  _data.push({
                    value: nestedKey,
                    label: data.state[nestedKey].label
                  });
                }
              }
            });
            object[key] = _data;
          }
        }
      }
    });
    return object;
  } catch (error) {
    return defaultPreference;
  }
};
//VERIFY IF THE JWT IS SET
const getMyPartnerPreferenceLocationDetail = createSelector(
  getData,
  preference => preference
);
export default getMyPartnerPreferenceLocationDetail;



// WEBPACK FOOTER //
// ./src/_selectors/userSelectors/getMyPartnerPreferenceLocationDetail.js